import { useContext, useEffect, useState } from 'react';

import CloudFunctionClientContext from 'contexts/CloudFunctionClientContext';

import getAdditionalPayments from '../../api/getAdditionalPayments';

// Loads a bonus record's recognition payments + the policy enforced for its
// period. Waits (loading) while there's no record id, e.g. while the slideout
// reloads the record; `hasFailed` is set when the read doesn't succeed.
const useAdditionalPayments = ({
  bonusDatasetRecordId,
}: {
  bonusDatasetRecordId: string | undefined;
}) => {
  const { api } = useContext(CloudFunctionClientContext);
  const [response, setResponse] = useState<
    BonusTypes.AdditionalPayments.Response | undefined
  >();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [hasFailed, setHasFailed] = useState<boolean>(false);

  useEffect(() => {
    if (bonusDatasetRecordId === undefined) {
      return;
    }

    let isActive = true;
    setResponse(undefined);
    setIsLoading(true);
    setHasFailed(false);
    getAdditionalPayments({ api, bonusDatasetRecordId }).then((r) => {
      if (!isActive) {
        return;
      }
      if (r.ok && r.data) {
        setResponse(r.data);
      } else {
        setHasFailed(true);
      }
      setIsLoading(false);
    });

    return () => {
      isActive = false;
    };
  }, [api, bonusDatasetRecordId]);

  return { response, setResponse, isLoading, hasFailed };
};

export default useAdditionalPayments;
